import { render, staticRenderFns } from "./AlertDetailDialog.vue?vue&type=template&id=1f6dbbca&scoped=true"
import script from "./AlertDetailDialog.vue?vue&type=script&lang=js"
export * from "./AlertDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./AlertDetailDialog.vue?vue&type=style&index=0&id=1f6dbbca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6dbbca",
  null
  
)

export default component.exports